export default "__VITE_ASSET__xzgZf9_y__"